import { Button } from '../../ui/Button/Button';
import Icon from '../Icon/Icon';
import { IconKeys } from '../Icon/IconKeys';
import S from './PaginationStyles';

function Pagination({
  setPage, prevPage, nextPage, currentPage, totalPages, isFetching,
}:any):JSX.Element {
  const handlePrevPage = ():void => setPage((prevPageState:number) => prevPageState - 1);
  const handleNextPage = ():void => setPage((prevPageState:number) => prevPageState + 1);

  return (
    <S.Wrapper>
      <Button
        height="32px"
        padding="7px 13px"
        onClick={handlePrevPage}
        disabled={!prevPage || isFetching}
      >
        <Icon iconKey={IconKeys.CHEVRON_RIGHT} />
      </Button>
      {currentPage && typeof totalPages === 'number' && (
        <p>{currentPage <= totalPages ? `${currentPage} / ${totalPages}` : currentPage}</p>
      )}
      <Button
        height="32px"
        padding="7px 13px"
        disabled={!nextPage || isFetching}
        onClick={handleNextPage}
      >
        <Icon iconKey={IconKeys.CHEVRON_RIGHT} />
      </Button>
    </S.Wrapper>
  );
}

export default Pagination;
